module.exports = __webpack_public_path__ + "img/sgs.0ee2d8c9.svg";